import React, { Component } from 'react';
import './AboutStyle.css';

class Card extends Component {
    render() {
        return (
            <div data-aos="fade-up" className="card__box">
                <div className="card__img" style={{ backgroundImage: `url('${this.props.img}')` }} />
                <div className="img__text">
                    <span className="img__header"><strong>{this.props.topic}</strong></span>
                    <p className="text-center"> Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut suscipit iure praesentium ullam soluta possimus, alias accusamus maiores dicta ipsa.</p>
                </div>
            </div>
        );
    }
}

export default Card;
